<script setup>
import { computed } from 'vue';

const props = defineProps({
    polynomial: {
        type: Object,
        required: true,
    },
});

const parts = computed(() => {
    const x = [];
    for (let i = 6; i >= 0; i--) {
        const value = props.polynomial[`x_${i}`];
        if (value) {
            x.push({
                value: value,
                power: i,
            });
        }
    }

    return x;
});

const max = computed(() => {
    let x = -1;
    for (let i = 6; i >= 0; i--) {
        const value = props.polynomial[`x_${i}`];
        if (value) {
            x = i;
            break;
        }
    }

    return x;
});
</script>

<template>
    <div class="flex gap-2">
        <div class="" v-for="part in parts" :key="part.power">
            <span v-if="part.value >= 0 && part.power !== max">+</span>
            <span>{{ part.value }}</span>
            <span class="italic" v-if="part.power > 0">{{ polynomial.label }}</span>
            <sup v-if="part.power > 1">{{ part.power }}</sup>
        </div>
    </div>
</template>
